import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useProjectTagsStyles = makeStyles((_) =>
  createStyles({
    root: {
      marginBottom: 25
    },
    indicator: {
      display: 'none'
    },
    tabWrapperActive: {
      height: '100%',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      textTransform: 'none',
      cursor: 'default'
    },
    tabWrapper: {
      height: '100%',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      textTransform: 'none',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        color: '#333333'
      }
    }
  })
)
